//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import { DangerButtonStyles } from '@components/atoms/button/buttonStyles';
import { BodyText } from '@components/atoms/text/Text';
import { Modal } from '@components/molecules/modal/Modal';
import { AiContentCurationTrackingIds } from '@media-library/ai-content-curation/constants/AiContentCurationTrackingIds';
import { Permissions } from '@models/Permissions';
import { pluralize } from '@utils/stringUtils';

interface BulkRejectConfirmationModalProps {
  isOpen: boolean;
  itemCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export const BulkRejectConfirmationModal = ({
  isOpen,
  itemCount,
  onCancel,
  onConfirm,
}: BulkRejectConfirmationModalProps) => {
  return (
    <Modal
      closeModal={onCancel}
      contents={<BodyText>Reject {pluralize(itemCount, 'item')}?</BodyText>}
      isModalOpen={isOpen}
      primaryButtonInfo={{
        buttonContent: 'Reject',
        buttonStyles: DangerButtonStyles,
        onClick: onConfirm,
        permissionName: Permissions.FanreelModerate,
        trackingId: AiContentCurationTrackingIds.BULK_REJECT_CONFIRM,
      }}
      secondaryButtonInfo={{
        buttonContent: 'Cancel',
        onClick: onCancel,
        trackingId: AiContentCurationTrackingIds.BULK_REJECT_CANCEL,
      }}
      title='Reject Content'
    />
  );
};
